module.exports = __webpack_public_path__ + "img/why-ico8.1e0cbf4c.png";